import ReactGA from "react-ga"

ReactGA.initialize({
  trackingId: process.env.REACT_APP_GA_TRACKING_ID,
})
